import {
  takeLatest, put, call, all,
} from 'redux-saga/effects';
import FhqUsersService from '@services/fhq-users';
import * as actions from '@actions';
import { FHQStatus, FhqUsers } from '@rootCommon/types/fhq';
import { IdType } from '@rootCommon/types/common';

import { AxiosError } from 'axios';
import { SagaGenerator } from './index';

// fetch
function* fetchFhqUsersAsync(action: { payload: IdType[] }) {
  try {
    const users: FhqUsers[] = yield all(
      action.payload.map((siteFhqId) => call(FhqUsersService.getBySiteFhqId, siteFhqId)),
    );

    yield put(actions.fetchFhqUsers.success(users));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.fetchFhqUsers.failure(error));
  }
}

function* watchFetchFhqUsers() {
  yield takeLatest(actions.fetchFhqUsers.request, fetchFhqUsersAsync);
}

// fetch
function* updateFhqUsersAsync(action: { payload: FhqUsers[] }) {
  const fhqIds = action.payload.map((item) => item.siteFhqId);

  try {
    const usersCreated = action.payload
      .map((item) => item.users
        .filter((user) => user.status === FHQStatus.CREATE)
        .map((user) => ({ siteFhqId: item.siteFhqId, userId: user.userId })))
      .flat();

    const usersDeleted = action.payload
      .map((item) => item.users
        .filter((user) => user.status === FHQStatus.DELETE)
        .map((user) => user.id))
      .flat();

    yield all(usersCreated.map((user) => call(FhqUsersService.create, user)));
    yield all(usersDeleted.map((id) => call(FhqUsersService.delete, id)));
    yield put(actions.updateFhqUsers.success());
    yield put(actions.fetchFhqUsers.request(fhqIds));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.updateFhqUsers.failure(error));
    yield put(actions.fetchFhqUsers.request(fhqIds));
  }
}

function* watchUpdateFhqUsers() {
  yield takeLatest(actions.updateFhqUsers.request, updateFhqUsersAsync);
}

// all
function* watchFhqUsers(): SagaGenerator {
  yield all([watchFetchFhqUsers(), watchUpdateFhqUsers()]);
}

export default watchFhqUsers;
